import { useSelector } from 'react-redux';
import style from './BurgerMenu.module.css';
import { useState } from 'react';
import { selectSignIn } from '../../../redux/auth/selectors';
import UserBurgerMenu from './UserBurgerMenu/UserBurgerMenu';
import HomeBurgerMenu from './HomeBurgerMenu/HomeBurgerMenu';
import { IoClose } from 'react-icons/io5';

const BurgerMenu = ({ isOpen, close }) => {
  const isLoginIn = useSelector(selectSignIn);

  if (!isOpen) return;
  return (
    <div className={style.burgerMenu}>
      {isLoginIn ? (
        <UserBurgerMenu close={close} />
      ) : (
        <HomeBurgerMenu close={close} />
      )}

      <IoClose
        className={style.closeButton}
        onClick={close}
        size={30}
        color="white"
        cursor="pointer"
      />
    </div>
  );
};

export default BurgerMenu;
